import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-200/70">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">移动观影</h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">{appEntry.subtitle}</p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {appEntry.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  {feat}
                </div>
              ))}
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-800 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-50 transition-colors"
              >
                <i className="ri-google-play-fill text-lg"></i>
                Google Play
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-sm">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={appEntry.image}
                alt="木瓜影视移动端App - 高清在线观看"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}